/**
 * Task list card — progress bar + checklist items with duration.
 *
 * CSS: styles/components/task-list.css
 */

import { esc } from '../../shared/rendering.js'
import type { TaskListProps } from '../../types/components.js'

/** Render a task list card with progress bar and individual items. */
export function renderTaskList(props: TaskListProps): string {
  const done = props.items.filter((i) => i.status === 'done').length
  const pct = props.items.length > 0 ? Math.round((done / props.items.length) * 100) : 0

  const itemsHtml = props.items
    .map((item) => {
      const chkCls = item.status === 'done' ? 'done' : item.status === 'active' ? 'act' : 'pend'
      const txtCls = item.status === 'done' ? 'done' : item.status === 'active' ? 'act' : ''
      const icon =
        item.status === 'done' ? '&#10003;' : item.status === 'active' ? '&#9654;' : '&#9675;'
      const durColor = item.status === 'active' ? 'color:var(--cyn)' : 'color:var(--t4)'
      return `<div class="si">
      <span class="si-chk ${chkCls}">${icon}</span>
      <span class="si-txt ${txtCls}" style="flex:1">${esc(item.text)}</span>
      <span style="font-family:var(--mono);font-size:9px;${durColor}">${item.duration !== null ? esc(item.duration) : '&mdash;'}</span>
    </div>`
    })
    .join('')

  return `<div class="scard">
    <div class="scard-h"><span class="scard-t">${esc(props.title)}</span><span class="scard-n">${esc(props.progress)}</span></div>
    <div class="scard-bar"><div class="scard-fill" style="width:${pct}%"></div></div>
    ${itemsHtml}
  </div>`
}
